import React, { useEffect, useMemo, useRef } from 'react'
import { createPortal } from 'react-dom'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import useKeypress from 'react-use-keypress'

import './Modal.scss'

const modalElement = document.getElementById('modal')

const Modal = ({ onClose, closeOnOverlayClick = true, children, isShowCloseIcon = false, closeOnEsc = true }) => {
    const modalRef = useRef(null)
    const el = useMemo(() => document.createElement('div'), [])

    useEffect(() => {
        modalElement.appendChild(el)
        disableBodyScroll(modalRef.current, { reserveScrollBarGap: true })

        return () => {
            if (modalElement.hasChildNodes()) {
                const _children = modalElement.childNodes
                _children.forEach(child => {
                    if (child === el) {
                        modalElement.removeChild(el)
                    }
                })
            }
            clearAllBodyScrollLocks()
        }
    }, [])

    useKeypress('Escape', () => {
        if (closeOnEsc) {
            onClose()
        }
    })

    return createPortal(
        <div className="modal-wrapper" ref={modalRef} onClick={() => closeOnOverlayClick && onClose()}>
            <div className="modal-wrapper__container">
                <div className="modal-wrapper__content" onClick={evt => evt.stopPropagation()}>
                    {isShowCloseIcon && (
                        <div className="modal-wrapper__close-icon" data-test="close-modal" onClick={onClose} />
                    )}
                    {children}
                </div>
            </div>
        </div>,
        el,
    )
}

export default Modal
